<div class="container">
    <div [formGroup]="address">
        <div class="row FlowupLabels">
            <div class="col-md-12">
                <!-- || formSubmitted -->
                <div class="validationwrap" [class.validation-error]="country.invalid && (country.dirty || country.touched)">
                    <div class="fl_wrap">
                        <label class="fl_label">Country</label>
                        <select #c class="fl_input" FlowUpLabel formControlName="country" (change)="OnCountrySelected(c.value)">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_Country" [value]="obj.acep_iso2code">{{obj.acep_name}}</option>
                        </select>
                        <span class="validationhead">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" [hidden]="HIDEORG">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Organization" formControlName="address1">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Address 1" formControlName="address2">
                    <mat-error *ngIf="address.get('address2').errors?.required">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Address 2" formControlName="address3">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="City" formControlName="city">
                    <mat-error *ngIf="address.get('city').errors?.required">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row FlowupLabels" *ngIf="ui_States.length > 0">
            <div class="col-md-12">
                <div class="validationwrap" [class.validation-error]="state.invalid && (state.dirty || state.touched || formSubmitted)">
                    <div class="fl_wrap">
                        <label class="fl_label">State/Province</label>
                        <select #s class="fl_input" FlowUpLabel formControlName="state" (change)="OnStateSelected(s.value)">
                            <option value=""></option>
                            <option *ngFor="let p of ui_States" [value]="p.acep_isocode">{{p.acep_name}}</option>
                        </select>
                        <span class="validationhead">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Zip/Postal Code" formControlName="zip">
                    <mat-error *ngIf="address.get('zip').errors?.required && country.value == 'US'">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>